import { httpClient } from "../../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../../utils/ApiEndpoint";

export const getRCSPartnerErrorsLogs = async ({ token, data = {} }) => {
  const response = await httpClient(
    "post",
    ApiEndpoint + "reports/rcs/partner-errors-logs",
    data,
    token,
  );

  return response.data;
};

export const fetchRCSPartnersByCustomer = async ({ token }) => {
  const response = await httpClient("GET", ApiEndpoint + `partners`, {}, token);

  return response.data;
};
